export default __webpack_public_path__ + "static/media/christmas_toy.17f97aaa.png";